'use client';

import {
	BASE_PRECISION_EXP,
	BigNum,
	QUOTE_PRECISION_EXP,
} from '@velocity-exchange/sdk';
import { cj } from 'src/utils/classNames';
import { baseSizeDisplayForPerpMarket } from 'src/utils/position';
import ValueChangeBlink from 'src/components/Utils/ValueChangeBlink';
import { AccountOpenPosition } from 'src/@types/positions';
import useShowAccountValues from 'src/hooks/useShowAccountValues';

interface SizeCellProps {
	position: AccountOpenPosition;
}

export function SizeCell({ position }: SizeCellProps) {
	const { baseSize, notional, direction, marketSymbol, isIsolatedBalanceOnly } =
		position;
	const showAccountValues = useShowAccountValues();

	if (isIsolatedBalanceOnly) {
		return <span className="text-text-secondary">-</span>;
	}

	const baseSizeBigNum = BigNum.from(baseSize.abs(), BASE_PRECISION_EXP);
	const notionalSize = BigNum.from(notional, QUOTE_PRECISION_EXP).toNotional();
	const notionalDisplay = showAccountValues ? notionalSize : '$ ∗∗∗∗∗∗';

	return (
		<div className="flex flex-col gap-y-xs">
			<span
				className={cj(
					'text-left',
					direction === 'long'
						? 'text-text-positive-green-button'
						: 'text-text-negative-red-button'
				)}
			>
				{baseSizeDisplayForPerpMarket(
					baseSizeBigNum,
					marketSymbol,
					!showAccountValues
				)}
			</span>
			<ValueChangeBlink value={notionalDisplay} className="text-left">
				<span className="typo-body-xs text-text-secondary">
					{notionalDisplay}
				</span>
			</ValueChangeBlink>
		</div>
	);
}
